import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from './constants';
import { TAgentFirmUsersResponse } from './types';

type UseAgentFirmUsersOptions = {
  agentFirmId: string;
  enabled?: boolean;
  includeArchived?: boolean;
};

export function useAgentFirmUsers(options: UseAgentFirmUsersOptions) {
  const { agentFirmId, enabled = true, includeArchived = false } = options;

  const url = agentFirmId
    ? `${API_BASE_PATH}/${agentFirmId}/users?includeArchived=${includeArchived ? 'true' : 'false'}`
    : null;

  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data?: TAgentFirmUsersResponse;
    error?: unknown;
    mutate: KeyedMutator<TAgentFirmUsersResponse>;
    isLoading: boolean;
  } = useSWR(
    enabled && url ? url : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data: data?.users ?? [],
    count: data?.count ?? 0,
    error,
    mutate,
    isLoading,
  };
}
